var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5070_22921)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    transform: "translate(0.5 0.496094)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4842 18.2327C55.6871 18.2167 55.8955 18.2865 56.0506 18.4417C56.0617 18.4527 56.0698 18.4662 56.0799 18.4778C56.0905 18.4898 56.1004 18.5022 56.1102 18.5149C56.128 18.5381 56.1444 18.5615 56.159 18.5862C56.164 18.5945 56.1681 18.6031 56.1727 18.6116C56.2085 18.6782 56.2346 18.7479 56.2479 18.8206C56.2511 18.8376 56.2518 18.8549 56.2538 18.8723C56.257 18.9017 56.261 18.9308 56.2606 18.9602V31.5188C56.2604 31.9162 55.9382 32.2383 55.5409 32.2386C55.1434 32.2385 54.8203 31.9163 54.8202 31.5188V20.6897L36.1522 39.3587C36.0172 39.4936 35.8333 39.5696 35.6424 39.5696C35.4517 39.5696 35.2686 39.4934 35.1337 39.3587L25.1708 29.3938L9.97057 44.594L9.85826 44.6868C9.5789 44.8712 9.199 44.8398 8.95299 44.594C8.67187 44.3129 8.67197 43.8567 8.95299 43.5755L24.662 27.8665L24.7713 27.7766C24.8889 27.6982 25.0284 27.6555 25.1717 27.6555C25.3625 27.6557 25.5456 27.7315 25.6805 27.8665L35.6424 37.8304L53.8016 19.6721H42.9745C42.5769 19.6721 42.2547 19.35 42.2547 18.9524C42.2548 18.5549 42.5769 18.2327 42.9745 18.2327H55.4842Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5070_22921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.5 0.496094)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.3035ebdaf743954d21c3767bf35a5287.svg";
export { ForwardRef as ReactComponent };